<template>
  <div>
    <NarrowContainer
      :canGoBack="true"
    >
      <MyInvoices />
    </NarrowContainer>
  </div>
</template>

<script>
import MyInvoices from '@/modules/myProfile/components/MyInvoices.vue';
import NarrowContainer from '@/layouts/NarrowContainer.vue';

export default {
  name: 'InvoicesPage',

  components: {
    MyInvoices,
    NarrowContainer
  },

  data () {
    return {
    };
  }
};
</script>

<style lang="less">

</style>
